<template>
    <div>
        <div v-if="!questions.length" class="ui-small ui-muted pa-4">{{ emptyText }}</div>
        <div v-for="(question, index) in questions" :key="question.id" class="rma-question">
            <div class="rma-question__order">{{ index + 1 }}</div>
            <div class="rma-question__main">
                <div class="ui-cell-main">{{ question.text }}<span v-if="question.required" class="rma-question__req" title="Obrigatória">*</span></div>
                <div class="ui-cell-sub">
                    {{ question.answer_type_label }}<template v-if="question.options && question.options.length">: {{ question.options.join(" · ") }}</template>
                </div>
                <div v-if="question.help" class="ui-cell-sub">Ajuda: {{ question.help }}</div>
            </div>
            <div class="rma-question__actions">
                <v-btn icon small :disabled="busy || index === 0" title="Subir" @click="move(index, -1)"><v-icon small>mdi-arrow-up</v-icon></v-btn>
                <v-btn icon small :disabled="busy || index === questions.length - 1" title="Descer" @click="move(index, 1)"><v-icon small>mdi-arrow-down</v-icon></v-btn>
                <v-btn v-if="$allowed($route.path.endsWith('/questionario') ? 'rma.template' : 'rma.questionnaire')" icon small :disabled="busy" title="Editar" @click="$emit('edit', question)"><v-icon small>mdi-pencil-outline</v-icon></v-btn>
                <v-btn v-if="$allowed($route.path.endsWith('/questionario') ? 'rma.template' : 'rma.questionnaire')" icon small :disabled="busy" title="Excluir" class="ui-btn-danger" @click="$emit('remove', question)"><v-icon small>mdi-delete-outline</v-icon></v-btn>
            </div>
        </div>
    </div>
</template>

<script>
// Lista de perguntas do questionario com ordenacao, edicao e exclusao.
export default {
    name: "RmaQuestionList",

    props: {
        questions: { type: Array, default: () => [] },
        busy: { type: Boolean, default: false },
        emptyText: { type: String, default: "Nenhuma pergunta cadastrada." },
    },

    methods: {
        move(index, delta) {
            const ids = this.questions.map((question) => question.id);
            const [id] = ids.splice(index, 1);
            ids.splice(index + delta, 0, id);
            this.$emit("reorder", ids);
        },
    },
};
</script>

<style scoped>
.rma-question {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border-top: 1px solid #eef2f6;
}

.rma-question:first-of-type {
    border-top: 0;
}

.rma-question__order {
    flex: none;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #f1effa;
    color: #2b2050;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rma-question__main {
    flex: 1;
    min-width: 0;
}

.rma-question__req {
    color: #b42318;
    margin-left: 2px;
}

.rma-question__actions {
    flex: none;
    display: flex;
    gap: 2px;
}
</style>
